import App from "../../modules/Core/Components/App";
import template from "../templates/app";
import Services from "../Services/Services";

export default class MainApp extends App {
  template = template;

  getOnResizeResolusion(width) {
    if (width < 500) {
      return "mobile";
    }

    if (width >= 500) {
      return "default";
    }
  }

  newsletterSubscribe(email) {
    Services.get("hook").then(async ([hookService]) => {
      const response = await hookService.post("subscribe", {
        email,
      });

      if (response.isValid()) {
        const data = response.getData();
        const valid = data === "ok";

        this.getComponents()
          .findById("main-message")
          .first()
          .setData({
            [`${valid ? "success" : "error"}-message`]: valid
              ? "subscribed"
              : data,
          });
      }
    });
  }

  priceFormater(price) {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(price);
  }

  priceFormaterDecimal(price) {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(price);
  }

  updateWindowTitle(title) {
    this.getPage().setWindowTitle(title);

    window.dataLayer.push({
      event: "pageviewCustomEvent",
      pagePath: window.location.pathname,
      pageTitle: title,
    });
    return this;
  }

  sendToGA4(product, event, amount) {
    if (product) {
      const { slug, name, price, types = [] } = product.item;
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: event,
        ecommerce: {
          items: [
            {
              item_id: slug,
              item_name: name,
              index: 0,
              item_brand: "il Palatino",
              item_category:
                types.length !== 0 ? types[0].item._values.name : null,
              price: price,
              quantity: amount || 1,
            },
          ],
        },
      });
    }
  }

  sendToGA4Order(order) {
    const {
      amounts,
      coupon,
      guest,
      items,
      paymentType,
      totals,
      _id,
      delivery_type,
      spot,
    } = order;

    const final_items = items.map((pr, index) => {
      const { slug, name, types = [] } = pr.item;
      return {
        item_id: slug,
        item_name: name,
        affiliation: spot.name,
        index: 0,
        item_brand: "il Palatino",
        item_category: types.length !== 0 ? types[0].item._values.name : null,
        price: pr.price,
        quantity: pr.amount,
      };
    });

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "purchase",
      ecommerce: {
        transaction_id: _id,
        user: guest ? "guest" : "subscribed",
        total_items: amounts.items,
        value: totals.grand,
        items_total: totals.items,
        discount: totals.discount ? totals.discount : 0,
        shipping: totals.services,
        payment_type: paymentType.name,
        delivery_type: delivery_type,
        spot: spot.name,
        currency: "EUR",
        coupon: coupon ? coupon.name : null,
        items: final_items,
      },
    });
  }
}
